import React from 'react';

// Text wordmark logo styled like the Fetchapro logo: an icon + bold two-tone text.
// "Open Sesame" in dark navy, "Garage Doors" in brand orange.
export const Logo = ({ className = '', size = 'md' }) => {
  const dims = {
    sm: { icon: 26, t1: 'text-base', t2: 'text-[10px]' },
    md: { icon: 34, t1: 'text-xl sm:text-2xl', t2: 'text-[11px] sm:text-xs' },
    lg: { icon: 42, t1: 'text-2xl sm:text-3xl', t2: 'text-xs sm:text-sm' },
  }[size];

  return (
    <span className={`inline-flex items-center gap-2.5 ${className}`}>
      {/* House + arrow icon (brand orange) */}
      <svg
        width={dims.icon}
        height={dims.icon}
        viewBox="0 0 64 64"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden="true"
        className="shrink-0"
      >
        <path
          d="M32 6 L58 30 L50 30 L50 56 L14 56 L14 30 L6 30 Z"
          stroke="#E8A03C"
          strokeWidth="4"
          strokeLinejoin="round"
          fill="none"
        />
        {/* up arrow inside (open door / lift) */}
        <path
          d="M32 50 L32 28 M32 28 L24 36 M32 28 L40 36"
          stroke="#E8A03C"
          strokeWidth="4"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>

      <span className="flex flex-col leading-none">
        <span className={`font-slab font-extrabold tracking-tight ${dims.t1}`}>
          <span className="text-slate-900">Open Sesame</span>
        </span>
        <span
          className={`font-slab font-bold tracking-[0.18em] uppercase ${dims.t2}`}
          style={{ color: '#E8A03C' }}
        >
          Garage Doors
        </span>
      </span>
    </span>
  );
};
